import React, { useEffect } from "react";

import Header from "../Header/Header";
import Footer from "../Footer/Footer";

import "./Aniversariantes.scss";

const ASSETS = "/content/assets/images/aniversariantes";

const IMAGES = {
  topo: `${ASSETS}/aniversario_cima.gif`,
  pawsLeft: `${ASSETS}/paws.gif`,
  setas: `${ASSETS}/setas.gif`,
  pawsRight: `${ASSETS}/paws-2.gif`,
  frase: `${ASSETS}/frase.png`,
  baixo: `${ASSETS}/aniversario_baixo.gif`,
};

const Spacer = ({ size }) => (
  <div style={{ lineHeight: `${size}px`, height: size, fontSize: size }}>
    &#8202;
  </div>
);

const Aniversariantes = () => {
  useEffect(() => {
    document.title = "Clube Bravecto | Aniversariantes";
  }, []);

  return (
    <div id="Aniversariantes">
      <Header hideLoginButton />

      <main className="aniversariantes-wrap">
        <div className="aniversariantes-email">
          <table width="100%" cellPadding="0" cellSpacing="0" border="0">
            <tbody>
              <tr>
                <td valign="top" align="center">
                  <table
                    bgcolor="#ffffff"
                    align="center"
                    cellSpacing="0"
                    cellPadding="0"
                    border="0"
                    width="1080"
                    className="email-container"
                  >
                    <tbody>
                      <tr>
                        <td width="1080" align="center" bgcolor="#ffffff">
                          <table
                            width="100%"
                            border="0"
                            cellPadding="0"
                            cellSpacing="0"
                          >
                            <tbody>
                              <tr>
                                <td width="1080" align="center">
                                  <img
                                    src={IMAGES.topo}
                                    width="1080"
                                    alt=""
                                    className="img-full"
                                  />
                                </td>
                              </tr>

                              <tr>
                                <td className="aniversariantes-body">
                                  <Spacer size={10} />

                                  <table
                                    cellSpacing="0"
                                    cellPadding="0"
                                    border="0"
                                    className="aniversariantes-copy-row"
                                  >
                                    <tbody>
                                      <tr>
                                        <td width="142" align="center">
                                          <img
                                            src={IMAGES.pawsLeft}
                                            width="142"
                                            alt=""
                                            className="img-fixed img-paws-left"
                                          />
                                        </td>
                                        <td width="41" className="spacer-col">
                                          &#8202;
                                        </td>
                                        <td
                                          align="center"
                                          className="aniversariantes-copy"
                                        >
                                          <p className="texto-principal">
                                            Aquele que:{" "}
                                            <span className="c-azul">
                                              bagunça a casa
                                            </span>
                                            ,{" "}
                                            <span className="c-roxo">
                                              rouba espaço na cama
                                            </span>
                                            ,{" "}
                                            <span className="c-verde">
                                              dita até as regras da casa
                                            </span>
                                            .
                                            <br />
                                            Mas também daquele que
                                            <span className="c-rosa">
                                              {" "}
                                              transforma qualquer momento
                                              simples em uma lembrança especial.
                                            </span>
                                          </p>

                                          <Spacer size={21} />

                                          <p className="texto-destaque">
                                            E isso merece comemoração.
                                          </p>

                                          <Spacer size={21} />

                                          <img
                                            src={IMAGES.setas}
                                            width="62"
                                            alt=""
                                            className="img-fixed img-setas"
                                          />
                                        </td>
                                        <td width="41" className="spacer-col">
                                          &#8202;
                                        </td>
                                        <td width="116" align="center">
                                          <img
                                            src={IMAGES.pawsRight}
                                            width="116"
                                            alt=""
                                            className="img-fixed img-paws-right"
                                          />
                                        </td>
                                      </tr>
                                    </tbody>
                                  </table>

                                  <Spacer size={19} />

                                  <div className="aniversariantes-box">
                                    <Spacer size={21} />

                                    <p className="box-titulo">
                                      Por isso, o Clube Bravecto® preparou um
                                      presente especial para vocês aproveitarem
                                      juntos.
                                    </p>

                                    <Spacer size={16} />

                                    <p className="box-lista">
                                      • Descontos especiais
                                      <br />
                                      • Benefícios exclusivos
                                      <br />
                                      • Vantagens para membros do clube
                                      <br />
                                      • Condições especiais para seu pet
                                    </p>

                                    <Spacer size={16} />

                                    <a
                                      href="/clube-de-vantagens"
                                      className="aniversariantes-cta"
                                    >
                                      ACESSE TODOS OS SEUS BENEFÍCIOS
                                    </a>

                                    <Spacer size={21} />
                                  </div>

                                  <Spacer size={19} />

                                  <img
                                    src={IMAGES.frase}
                                    width="730"
                                    alt=""
                                    className="img-frase"
                                  />

                                  <Spacer size={10} />
                                </td>
                              </tr>

                              <tr>
                                <td width="1080" align="center">
                                  <img
                                    src={IMAGES.baixo}
                                    width="1080"
                                    alt=""
                                    className="img-full"
                                  />
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </main>

      <Footer />
    </div>
  );
};

export default Aniversariantes;
